import { makeReducerPermission } from "../../index";

export const inviteUserPermission = makeReducerPermission({
  reducerName: "inviteUser",
});
